import { Layers } from 'lucide-react'
import { useUiStore } from '../../../stores/ui'
import { cn } from '../../../lib/utils'

const layerOptions = [
  { key: 'devices', label: '监测节点' },
  { key: 'live', label: '实时触发' },
  { key: 'waves', label: '波传播' },
  { key: 'epicenters', label: '震中标记' },
  { key: 'intensity', label: '烈度圈' },
  { key: 'tracks', label: '志愿者轨迹' },
]

export function MapLayerSwitcher() {
  const activeLayers = useUiStore((s) => s.activeLayers)
  return (
    <div className="panel-glass absolute right-3 top-3 z-10 rounded-lg p-2.5">
      <div className="mb-1.5 flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
        <Layers size={12} /> 图层
      </div>
      <div className="space-y-1">
        {layerOptions.map((opt) => (
          <button
            key={opt.key}
            onClick={() => useUiStore.getState().toggleLayer(opt.key)}
            className={cn(
              'flex items-center gap-2 rounded px-2 py-1 text-[11px] transition',
              activeLayers.includes(opt.key) ? 'text-primary' : 'text-muted-foreground/70 hover:text-foreground',
            )}
          >
            <span
              className={cn(
                'grid size-3.5 place-items-center rounded-sm border',
                activeLayers.includes(opt.key) ? 'border-primary bg-primary/30' : 'border-border',
              )}
            >
              {activeLayers.includes(opt.key) && <span className="size-1.5 rounded-full bg-primary" />}
            </span>
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  )
}
